import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box sx={{ p: 3, textAlign: 'center' }}>
    <Typography>© 2023 All rights reserved by Maison-Isor </Typography>
  </Box>
);

export default Footer;
